import React from "react";
import PropTypes from "prop-types";
import { Grid2 } from "@mui/material";
// styles
import styles from "./EmptyState.module.scss";
import WelcomePlanCard from "../WelcomePlanCard/WelcomePlanCard";

export default function NewEmptyState({
  header,
  subHeader,
  title,
  title1,
  subTitle,
  icon: Icon,
}) {
  return (
    <Grid2 className={styles.NewemptyStateContainer}>
      <Grid2 className={styles.headerFlexBox}>
        <Grid2 className={styles.header}>{header}</Grid2>
        <Grid2 className={styles.subHeader}>{subHeader}</Grid2>
      </Grid2>
      <Grid2 className={styles.ImageContainer}>
        <Grid2 className={styles.flexBox}>
          <Grid2 className={styles.headerText}>
            <Grid2>
              <span className={styles.title}>{title}</span>
              <span className={styles.title1}>{title1 ? title1 : ""}</span>
            </Grid2>
            <Grid2 className={styles.desc}>{subTitle}</Grid2>
          </Grid2>
          <Grid2 className={styles.imageSize}>
            {Icon ? <Icon className={styles.icon} /> : ""}
          </Grid2>
        </Grid2>
        <WelcomePlanCard />
      </Grid2>
    </Grid2>
  );
}

NewEmptyState.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  icon: PropTypes.elementType.isRequired,
};
